/** Операции размещения менеджера — единственная точка знания о путях (ядро S2). */

import { request, type QueryParams, type Schemas } from "../../api/client";

export type PlacementList = Schemas["PlacementListOut"];
export type PlacementRow = Schemas["PlacementRowOut"];
export type PlacementIn = Schemas["PlacementIn"];
export type PlacementPatchIn = Schemas["PlacementPatchIn"];
export type PlacementWrite = Schemas["PlacementWriteOut"];
export type ImportBatch = Schemas["ImportBatchOut"];
export type ImportDetail = Schemas["ImportBatchDetail"];
export type ImportRow = Schemas["ImportRowOut"];
export type PlacementWarnings = Schemas["PlacementWarningsOut"];

const json = (method: string, body?: unknown): RequestInit => ({
  method,
  ...(body === undefined ? {} : { body: JSON.stringify(body) }),
});

export const placementApi = {
  list: (params: QueryParams) => request<PlacementList>("/placements", params),
  create: (body: PlacementIn, params: QueryParams) =>
    request<PlacementWrite>("/placements", params, json("POST", body)),
  patch: (id: number, body: PlacementPatchIn, params: QueryParams) =>
    request<PlacementWrite>(`/placements/rows/${id}`, params, json("PATCH", body)),
  remove: (id: number, params: QueryParams) =>
    request<{ deleted: number }>(`/placements/rows/${id}`, params, json("DELETE")),
  conflicts: (params: QueryParams) =>
    request<PlacementWarnings>("/placements/conflicts", params),
  upload: (file: File, adapter: string, season: string, params: QueryParams) => {
    const form = new FormData();
    form.set("file", file);
    form.set("adapter", adapter);
    form.set("season", season);
    return request<ImportBatch>("/placements/import", params, {
      method: "POST",
      body: form,
    });
  },
  importDetail: (id: number, params: QueryParams) =>
    request<ImportDetail>(`/placements/import/${id}`, params),
  commit: (id: number, params: QueryParams) =>
    request<ImportBatch>(`/placements/import/${id}/commit`, params, json("POST")),
  reject: (id: number, params: QueryParams) =>
    request<ImportBatch>(`/placements/import/${id}/reject`, params, json("POST")),
};
